var map = {
	"./admin-dashboard-card.avif": 4796,
	"./challenges-card.avif": 3846,
	"./coinflip-card.avif": 470,
	"./custom-challenges-card.avif": 8282,
	"./custom-web-design-card.avif": 5393,
	"./divider-transparent.avif": 6503,
	"./divider.avif": 1532,
	"./gradient-star.avif": 6778,
	"./guess-the-balance-card.avif": 5728,
	"./guess-the-payout-card.avif": 7492,
	"./hero-cards.avif": 5553,
	"./hero-zachdevworks.avif": 8063,
	"./leaderboard-card.avif": 5039,
	"./left-corner.png": 7669,
	"./max-video-card.avif": 2934,
	"./mines-card.avif": 9534,
	"./myrtlebot-background.png": 3457,
	"./myrtlebot-logo.avif": 2967,
	"./projects/abughazi.avif": 667,
	"./projects/alex-bonuses.png": 8633,
	"./projects/austinski.avif": 1989,
	"./projects/awake.avif": 6713,
	"./projects/ballyboy.avif": 1408,
	"./projects/bcdegens.avif": 2205,
	"./projects/betgemzz.avif": 2592,
	"./projects/booth.avif": 5946,
	"./projects/chilislots.avif": 3692,
	"./projects/chuckauee.avif": 3362,
	"./projects/cleanswipe.avif": 7319,
	"./projects/fugroo.avif": 9496,
	"./projects/gabbidoto.avif": 1433,
	"./projects/hanvee.avif": 9343,
	"./projects/kaneyy.avif": 8605,
	"./projects/kicksword.png": 134,
	"./projects/maherco.avif": 1014,
	"./projects/mikhailis.avif": 743,
	"./projects/moonlight.avif": 5089,
	"./projects/mrchocolate.avif": 2597,
	"./projects/mysticbert.avif": 4444,
	"./projects/pezslaps.avif": 7924,
	"./projects/romieinc.avif": 2874,
	"./projects/seham1.avif": 6263,
	"./projects/setokaiba.avif": 9783,
	"./projects/slotden.avif": 1969,
	"./projects/stilltre.avif": 9749,
	"./projects/tslots.avif": 6627,
	"./projects/twinslots.avif": 1901,
	"./projects/twixa.avif": 4777,
	"./projects/vivstream.avif": 903,
	"./projects/wiema.png": 3428,
	"./projects/winfest.png": 7679,
	"./projects/zingosquad.avif": 105,
	"./quotes.avif": 2678,
	"./raffle-system-card.avif": 7418,
	"./right-corner.png": 7392,
	"./roulette-card.avif": 3616,
	"./services-container-center-inactive.avif": 3437,
	"./services-container-center.avif": 2713,
	"./services-container-left.avif": 305,
	"./services-container-right.avif": 8006,
	"./socials-card.avif": 9250,
	"./verified.avif": 6735,
	"./videos-bg.avif": 1489,
	"./virtual-store-card.avif": 383,
	"./zach_dev_works_background.png": 9126,
	"./zach_dev_works_logo.avif": 9602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;